import { Icons, Button, HexIcon, tokens } from '@cast/design-system';
import { useTrial, TrialBannerLayout } from '@cast/shared-trial-ui';

import { useIsOrganizationReadOnly } from 'hooks/useIsOrganizationReadOnly';

import { useTrialInProgressDialog } from '../dialogs/useTrialInProgressDialog';

export const TrialAboutToEndBanner = () => {
  const accountReadOnly = useIsOrganizationReadOnly();
  const { isEligible, state, isAboutToExpire } = useTrial();
  const { openDialog: openTrialInProgressDialog } = useTrialInProgressDialog();

  if (
    !isEligible ||
    accountReadOnly ||
    !isAboutToExpire ||
    state !== 'active'
  ) {
    return null;
  }

  return (
    <TrialBannerLayout
      testId="trial-changed-mind-banner"
      sx={{
        backgroundColor: tokens.theme.bg.categorical.redSubtle,
        border: '1px solid',
        borderColor: tokens.theme.border.status.error,
      }}
      icon={
        <HexIcon
          icon={<Icons.XCircle />}
          size={58}
          iconColor={tokens.theme.fg.status.error}
          hexColor={tokens.theme.data.red200}
        />
      }
      title="Your trial is ending soon!"
      titleTypographyProps={{
        color: 'textPrimary',
      }}
      description="Continue using advanced monitoring, autoscaling, and security features for your cluster. Schedule a call with our team to learn about upgrading."
      descriptionTypographyProps={{
        color: 'textSecondary',
      }}
      cta={
        <Button
          variant="ghost"
          endIcon={<Icons.ArrowRight />}
          onClick={() => openTrialInProgressDialog()}
        >
          Take actions
        </Button>
      }
    />
  );
};
